import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { ReportHeading } from '../common/ReportHeading'
import { Item } from '../../../common/snippets'
import { Box, Button, Radio } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import { useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import moment from 'moment/moment'
import { appendToUrl, diffInMonths, focusElemnt, getPaymentTypeBackground, getStatusBackground, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { SplitButton } from '../../../common/SplitButton'
import BkngDelvryTrackingTable from './BkngDelvryTrackingTable'
import * as urlsValue from '../oldReportsUrls'
import ManageColumns from '../../../common/ManageColumnsUI'
import { updateModal } from '../../../../store/common/common_action'
import { getCargoRoleRightsConfigListAll, updateAlertError } from '../../../../store/common/common_action'
import { getTrackingReportFilters, getTrackingReportTableData } from '../../../../store/reports/reports_action'
import { PaymentTypesOptions, urls, xlColq } from '../../../common/constants'
import { bookAndDelHeader, bookAndDelHeaderForSTA, filterHeaders, paymentTypeStyles, statusCellStyles, summaryTableHead, trimmedTextStyle, } from './const'
import BkngDelvryTrackingTableTwo from './BkngDelvryTrackingTableTwo'
import { BkngDelvryTrackingSummary } from './BkngDelvryTrackingSummary'
import { useAtom, useSetAtom } from 'jotai'
import { companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { GetRequest } from '../../../common/api'
import { globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { STA_COMPANY_ID } from '../../../../helper/companyIdhardcode'
const viewTypeList = [
  { id: 1, name: 'Detailed' },
  { id: 2, name: 'Summary' },
]

const BkngDelvryTrackingReport = (props) => {
  const {
    data: { common, reports },
    updateModal, getCargoRoleRightsConfigListAll, getTrackingReportFilters, getTrackingReportTableData, updateAlertError } = props
  const { loginData, roleRights, showModal, modalType } = common
  const companyId = loginData?.intCompanyID;
  const [companySettings] = useAtom(companySettingsAtom)
  const { DefaultCurrencyID = 0, UseFormattedLRinReports, UseToPayAsCOD } = companySettings
  const { trackingReportFilter, trackingReportTableData } = reports
  const { IsAdmin, IsBranchAdmin, IsMTPLAdmin } = loginData
  let reportName = "Booking And Delivery Tracking";
  const loginCountryId = DefaultCurrencyID
  if (DefaultCurrencyID === 2) {
    reportName = "Parcel Journey";
  }
  const [showTable, setShowTable] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [companyName, setCompanyName] = useState('')
  const [selectedRadio, setSelectedRadio] = useState('Booking')
  const [srcState, setSrcState] = useState('')
  const [srcCity, setSrcCity] = useState('')
  const [srcBranch, setSrcBranch] = useState('')
  const [destState, setDestState] = useState('')
  const [destCity, setDestCity] = useState('')
  const [destBranch, setDestBranch] = useState('')
  const [paymentType, setPaymentType] = useState('')
  const [consignmentType, setConsignmentType] = useState('')
  const [transactionType, setTransactionType] = useState('')

  const [viewType, setViewType] = useState(viewTypeList[0])
  const [srcStateList, setSrcStateList] = useState([])
  const [srcCityList, setSrcCityList] = useState([])
  const [srcBranchList, setSrcBranchList] = useState([])
  const [destStateList, setDestStateList] = useState([])
  const [destCityList, setDestCityList] = useState([])
  const [destBranchList, setDestBranchList] = useState([])
  const [consTypeList, setConsTypeList] = useState([])
  const [manageColumn, setManageColumn] = useState([])
  const [allowViewAll, setAllowViewAll] = useState(0)
  const [selectedFields, setSelectedFields] = useState([])
  const [disableBtn, setDisableBtn] = useState(false)
  const setLoader = useSetAtom(globalLoaderAtom)
  const [tableDataForSummary, setTableDataForSummary] = useState([])
  const [tableData, setTableData] = useState([])
  const filterObj = {
    SourceStateID: srcState?.name,
    SourceCityID: srcCity?.name,
    SourceBranchID: srcBranch?.name,
    DestStateID: destState?.name,
    DestCityID: destCity?.name,
    DestBranchID: destBranch?.name,
    PaymentType: paymentType?.Name,
    ConsTypeID: consignmentType?.name,
    ReportMode: transactionType?.name,
    dataType: 'entry',
  }
  //const [trnsTypeList, setTrnsTypeList] = useState()
  const trnsTypeList = [
    // { id: 0, name: 'All' },
    { id: 'B', name: 'Booking' },
    { id: 'D', name: 'Delivery' },
  ]
  const columns = bookAndDelHeader(UseFormattedLRinReports)
  const columnsSTA = bookAndDelHeaderForSTA()
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || roleRights?.Table1?.[0]?.AllowBranchInchargeRights || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin))
    }
  }, [roleRights, loginData])
  useEffect(() => {
    focusElemnt('isBookingDateWise')
    setTransactionType(trnsTypeList[0])
    setPaymentType(PaymentTypesOptions[0])
  }, [])
  useEffect(() => {
    getCargoRoleRightsConfigListAll(loginData, true, 24 * 60 * 60 * 1000)
  }, [loginData])

  useEffect(() => {
    if (IsAdmin || IsBranchAdmin || IsMTPLAdmin || roleRights?.AllowViewAllBranchReport) {
      setAllowViewAll(1)
    }
  }, [loginData, roleRights])
  useEffect(() => {
    let fields = manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})
    setSelectedFields(fields)
  }, [manageColumn])

  useEffect(() => {
    const updateColumnDetails = () => {
      try {
        const localData = localStorage.getItem('columns')
        if (localData) {
          setManageColumn(JSON.parse(localData))
        } else {
          setManageColumn(columns)
        }
      } catch (error) {
        console.error(error)
        setManageColumn(columns)
      }
    }
    updateColumnDetails()
  }, [UseFormattedLRinReports])

  useEffect(() => {
    if (trackingReportFilter?.length > 0) {
      const {
        lists: [sourceStateList, sourceCityList, sourceBranchList, destStateList, destCityList, destBranchList, consTypeList],
        matched: { sourceState, sourceCity, sourceBranch, destState, destCity, destBranch },
      } = trackingReportFilter.reduce(
        (acc, obj) => {
          const {
            sets: { sourceStates, sourceCities, sourceBranches, destStates, destCities, destBranches, consTypes },
            lists,
            matched,
          } = acc

          // --- Source State ---
          if (!sourceStates.has(obj.SourceStateID)) {
            sourceStates.add(obj.SourceStateID)
            lists[0].push({ id: obj.SourceStateID, name: obj.SourceState })
          }
          // --- Source City ---
          if (!sourceCities.has(obj.SourceCityID)) {
            sourceCities.add(obj.SourceCityID)
            lists[1].push({ id: obj.SourceCityID, name: obj.SourceCity, stateId: obj.SourceStateID })
          }
          if (!matched.sourceCity && obj.SourceCityID === loginData?.intBranchCityID) {
            matched.sourceState = { id: obj.SourceStateID, name: obj.SourceState }
            matched.sourceCity = { id: obj.SourceCityID, name: obj.SourceCity, stateId: obj.SourceStateID }
          }

          // --- Source Branch ---
          if (!sourceBranches.has(obj.SourceBranchID)) {
            sourceBranches.add(obj.SourceBranchID)
            lists[2].push({ id: obj.SourceBranchID, name: obj.SourceBranch, cityId: obj.SourceCityID, stateId: obj.SourceStateID })
          }
          if (!matched.sourceBranch && obj.SourceBranchID === loginData?.intBranchID) {
            matched.sourceBranch = {
              id: obj.SourceBranchID,
              name: obj.SourceBranch,
              cityId: obj.SourceCityID,
              stateId: obj.SourceStateID,
            }
          }

          // --- Dest State ---
          if (!destStates.has(obj.DestStateID)) {
            destStates.add(obj.DestStateID)
            lists[3].push({ id: obj.DestStateID, name: obj.DestState })
          }
          // --- Dest City ---
          if (!destCities.has(obj.DestCityID)) {
            destCities.add(obj.DestCityID)
            lists[4].push({ id: obj.DestCityID, name: obj.DestCity, stateId: obj.DestStateID })
          }
          if (!matched.destCity && obj.DestCityID === loginData?.intBranchCityID) {
            matched.destState = { id: obj.DestStateID, name: obj.DestState }
            matched.destCity = { id: obj.DestCityID, name: obj.DestCity, stateId: obj.DestStateID }
          }

          if (!destBranches.has(obj.DestBranchID)) {
            destBranches.add(obj.DestBranchID)
            lists[5].push({ id: obj.DestBranchID, name: obj.DestBranch, cityId: obj.DestCityID, stateId: obj.DestStateID })
          }
          if (!matched.destBranch && obj.DestBranchID === loginData?.intBranchID) {
            matched.destBranch = {
              id: obj.DestBranchID,
              name: obj.DestBranch,
              cityId: obj.DestCityID,
              stateId: obj.DestStateID,
            }
          }
          if (!consTypes.has(obj.ConsignmentSubTypeID)) {
            consTypes.add(obj.ConsignmentSubTypeID)
            lists[6].push({ id: obj.ConsignmentSubTypeID, name: obj.ConsignmentSubType })
          }

          return acc
        },
        {
          sets: {
            sourceStates: new Set(),
            sourceCities: new Set(),
            sourceBranches: new Set(),
            destStates: new Set(),
            destCities: new Set(),
            destBranches: new Set(),
            consTypes: new Set(),
          },
          lists: [
            [{ id: 0, name: 'All' }], // sourceStateList
            [{ id: 0, name: 'All' }], // sourceCityList
            [{ id: 0, name: 'All' }], // sourceBranchList
            [{ id: 0, name: 'All' }], // destStateList
            [{ id: 0, name: 'All' }], // destCityList
            [{ id: 0, name: 'All' }], // destBranchList
            [{ id: 0, name: 'All' }], // consTypeList
          ],
          matched: {
            sourceState: null,
            sourceCity: null,
            sourceBranch: null,
            destState: null,
            destCity: null,
            destBranch: null,
          },
        }
      )
      setSrcStateList(sourceStateList)
      setSrcCityList(sourceCityList)
      setSrcBranchList(sourceBranchList)
      setDestStateList(destStateList)
      setDestCityList(destCityList)
      setDestBranchList(destBranchList)
      setConsTypeList(consTypeList)

      if (disableBtn && transactionType?.id === 'B') {
        setSrcState(sourceState || {})
        setSrcCity(sourceCity || {})
      } else {
        if (sourceStateList?.length) {
          setSrcState(sourceStateList[0])
        }
        if (sourceCityList?.length) {
          setSrcCity(sourceCityList[0])
        }
      }
      if (disableBtn && transactionType?.id === 'B' && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport === 0) {
        setSrcBranch(sourceBranch || {})
      } else {
        if (sourceBranchList?.length) {
          setSrcBranch(sourceBranchList[0])
        }
      }
      if (disableBtn && transactionType?.id === 'D') {
        setDestState(destState)
        setDestCity(destCity)
        setDestBranch(destBranch)
      } else {
        if (destStateList?.length) {
          setDestState(destStateList[0])
        }
        if (destCityList?.length) {
          setDestCity(destCityList[0])
        }
        if (destBranchList?.length) {
          setDestBranch(destBranchList[0])
        }
      }
      if (consTypeList?.length) {
        setConsignmentType(consTypeList[0])
      }
      setCompanyName(loginData.strCompanyName)
    }
  }, [trackingReportFilter, disableBtn, transactionType])
  const handleClickGo = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const obj = {
        CompanyID: loginData.intCompanyID,
        dtFromDate: fromDate.format('YYYY-MM-DD'),
        dtToDate: toDate.format('YYYY-MM-DD'),
        DateMode: selectedRadio === 'Booking' ? 'B' : 'D',
        UserID: loginData?.intUserID
      }
      getTrackingReportFilters(obj)
      focusElemnt('bdtTransactionType');
    }
  }
  const calculateTotal = (data, columns) => {
    if (!data?.length || !columns?.length) return {};

    const totalRow = {
      dataType: 'total',
      SN: '',
      sn: '',
    };

    columns.forEach((col, index) => {
      const key = col.field || col.accessor || col.id;
      if (!key) return;

      const isNumericColumn =
        col.dataType === 'number' ||
        col.type === 'number' ||
        col.isNumeric ||
        col.xlCol === xlColq;

      if (isNumericColumn) {
        totalRow[key] = Number(
          data
            .reduce((sum, row) => {
              let value = row?.[key];
              // ✅ HANDLE AWEIGHT / CWEIGHT LIKE BEFORE
              if (
                (key === 'AWEIGHT' || key === 'CWEIGHT') &&
                typeof value === 'string'
              ) {
                value = value
                  .split(',')
                  .reduce((a, b) => a + Number(b || 0), 0);
              }
              const num = Number(value);
              return sum + (isNaN(num) ? 0 : num);
            }, 0)
            .toFixed(2)
        );
      } else {
        totalRow['ReceiverGSTN'] = 'TOTAL'
      }
    });

    return totalRow;
  };
  const formatData = ({
    data = [],
    viewType,
    companyId,
    columns,
    columnsSTA,
  }) => {
    if (!data?.length) return [];

    // 🔥 Row formatter (useEffect wala logic)
    const transformRow = (item, index) => ({
      ...item,
      SN: index + 1,
      sn: index + 1,

      CartageCharge:
        Number(item.PickupCartage || 0) +
        Number(item.CommCartage || 0) +
        Number(item.ReturnCartage || 0) +
        Number(item.MsclCart || 0) +
        Number(item.DeliveryCartage || 0),

      'LRNO^^ManualLRNo': `${item.LRNO ?? ''}\n${item.ManualLRNo ?? ''}`,
      'SourceCity^^SourceBranch': `${item.SourceCity ?? ''}\n${item.SourceBranch ?? ''}`,
      'DestCity^^DestBranch': `${item.DestCity ?? ''}\n${item.DestBranch ?? ''}`,
      'Sender^^SenderMobileNo': `${item.Sender ?? ''}\n${item.SenderMobileNo ?? ''}`,
      'RecName^^RecMobileNo': `${item.RecName ?? ''}\n${item.RecMobileNo ?? ''}`,
      'PartyBillNo^^PartyBillDate': `${item.PartyBillNo ?? ''}\n${item.PartyBillDate ?? ''}`,
      BookingDate: item?.BookingDate?.split(' ')[0] || '',
      BookingTime: item?.BookingDate?.split(' ').slice(1).join(' ') || '',
      RefundDate: item?.RefundDate?.split(' ')[0] || '',
      RefundTime: item?.RefundDate?.split(' ').slice(1).join(' ') || '',
      FormattedLRNO: item.FormattedLRNO,
      BookingDateFormated: item.BookingDate?.slice(0, 10),
      BookingTimeFormated: item.BookingDate?.slice(11, 19),

      dataType: 'entry',
    });

    const newData = data.map(transformRow);

    // ✅ decide columns
    let selectedColumns = columns;
    if ([STA_COMPANY_ID].includes(companyId)) {
      selectedColumns = columnsSTA;
    }

    // ✅ Detailed view → add total
    if (viewType?.id === 1) {
      const totalRow = calculateTotal(newData, selectedColumns);
      return [...newData, totalRow];
    }

    // ✅ Summary view → no total
    return newData;
  };
  const handleClick1 = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' });
      return;
    }
    if (srcState === '' || srcBranch === '' || srcCity === '' || destState === '' || destCity === '' || destBranch === '' || paymentType === '' || consignmentType === '' || transactionType === '') {
      updateAlertError({ show: true, msg: 'Please Select The Filter Options ', nextId: '' });
      return;
    }
    setShowTable(true);
    setLoader(true);
    const object = {
      CompanyID: loginData.intCompanyID,
      DateMode: selectedRadio === 'Booking' ? 'B' : 'D',
      dtFromDate: fromDate.format('YYYY-MM-DD'),
      dtToDate: toDate.format('YYYY-MM-DD'),
      SourceStateID: srcState?.id,
      SourceCityID: srcCity?.id,
      SourceBranchID: srcBranch?.id,
      DestStateID: destState?.id,
      DestCityID: destCity?.id,
      DestBranchID: destBranch?.id,
      PaymentType: paymentType?.id,
      ConsTypeID: consignmentType?.id,
      ReportMode: transactionType?.id,
      UserID: loginData?.intUserID,
      AllowViewAllReport: allowViewAll,
    };
    const transformPaymentType = (item) => {
      let updatedPaymentType = item.PaymentType;
      if (UseToPayAsCOD === 1 && item.PaymentType === "To-Pay") {
        updatedPaymentType = "COD";
      } else if (item.PaymentType === "To-Pay(MANUAL)") {
        updatedPaymentType = "COD(MANUAL)";
      } else if (item.PaymentType === "To-Pay(DDDV)") {
        updatedPaymentType = "COD(DDDV)";
      }
      return {
        ...item,
        PaymentType: updatedPaymentType,
        PayType: updatedPaymentType,
      };
    };
    GetRequest(urls.getTrackingReportData, object)
      .then((res) => {
        setLoader(false);
        if (res.status === 'Success') {
          const updatedData = {
            ...res,
            Data: {
              ...res.Data,
              Table: res?.Data?.Table?.map(transformPaymentType),
            },
          };
          let reportData = formatData({
            data: updatedData?.Data?.Table,
            viewType,
            companyId,
            columns,
            columnsSTA,
          });
          if (reportData?.length > 0) {
            let mainHeader = [];
            let reportPayload = {};
            if (viewType?.id === 1) {
              if ([STA_COMPANY_ID].includes(companyId)) {
                mainHeader = columnsSTA.map((val) => ({
                  ...val,
                  // align: val.headerSx.textAlign,
                  align: val.xlCol.dataType === 'string' ? 'left' : 'right',
                  export: val.exportHead,
                  weight: 80,
                }));
                reportPayload = {
                  reportName,
                  criteriaHeaders: filterHeaders,
                  criteriaData: [filterObj],
                  tableData: reportData,
                  mainHeader: mainHeader,
                  isShowPdfPrint: false,
                  colSpanMarker: 'ReceiverGSTN',
                  showColumnBorders: true,
                };
              } else {
                mainHeader = columns.map((val) => ({
                  ...val,
                  // align: val.headerSx.textAlign,
                  align: val.xlCol.dataType === 'string' ? 'left' : 'right',
                  export: val.exportHead,
                  weight: 80,
                }));
                reportPayload = {
                  reportName,
                  criteriaHeaders: filterHeaders,
                  criteriaData: [filterObj],
                  tableData: reportData,
                  mainHeader: mainHeader,
                  isShowPdfPrint: false,
                  isShowManageColumn: true,
                  manageColumnID: 'qwertvcxasfdfg',
                  colSpanMarker: 'ConsType',
                  isOpenPopupForSta: true,
                  defaultCurrencyID: DefaultCurrencyID,
                  showColumnBorders: true,
                  serialNokey : 'SN'
                };
              }
            } else {
              mainHeader = summaryTableHead.map((val) => ({
                ...val,
                align: val.xlCol.dataType === 'string' ? 'left' : 'right',
                export: val.exportHead,
                weight: 80,
              }));
              reportPayload = {
                reportName,
                criteriaHeaders: filterHeaders,
                criteriaData: [filterObj],
                isShowPdfPrint: false,
                tableData: reportData,
                mainHeader: mainHeader,
                hideHeader: false,
                showColumnBorders: true,
                serialNokey : 'sn'
              };
            }
            const rid = Date.now().toString();
            if (!window.generatedReports) {
              window.generatedReports = {};
            }
            window.generatedReports[rid] = reportPayload;
            window.open(`/view-report?rid=${rid}`, "_blank");
          }
        } else {
          updateAlertError({
            show: true, msg: res.ErrMessage
          });
        }
      })
      .catch(() => {
        setLoader(false);
        updateAlertError({ show: true, msg: 'Something went wrong' });
      });
  };
  const handleClick2 = () => {
    let url = urlsValue.bookingDeliveryTracking
    const urlData = urlsValue.bookingDeliveryTrackingParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.FromDt = fromDate.format('YYYY-MM-DD')
    urlData.ToDt = toDate.format('YYYY-MM-DD')
    urlData.intBookingType = paymentType?.id
    urlData.intConsignmentType = consignmentType?.id
    urlData.strReportMode = selectedRadio === 'Booking' ? 'B' : 'D'
    urlData.AllowViewAllReport = allowViewAll
    urlData.strDateMode = selectedRadio === 'Booking' ? 'B' : 'D'
    urlData.intAllMovementChk = 0
    urlData.intAllowExportExcel = roleRights?.Table1[0]?.AllowExportExcel
    urlData.intFranchMode = 0
    urlData.intFranchCompanyID = 0
    urlData.intFranchBranchID = 0
    urlData.intStateID = srcState?.id
    urlData.intCityID = srcCity?.id
    urlData.intBranchID = srcBranch?.id
    urlData.intToStateID = destState?.id
    urlData.intToCityID = destCity?.id
    urlData.intToBranchID = destBranch?.id
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handleChange = (e) => {
    setSelectedRadio(e.target.value)
    setShowTable(false)
  }

  const onSaveColumns = (items) => {
    setManageColumn(items)
    localStorage.setItem('columns', JSON.stringify(items))
  }
  const dataValues = {
    roleRights, trackingReportTableData,
    loginData, selectedRadio,
    fromDate, toDate, companyName,
    srcState, srcCity, srcBranch,
    destState, destCity, destBranch,
    paymentType, consignmentType, transactionType,
    selectedFields, manageColumn,
    loginCountryId: loginCountryId
  }

  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      setSelectedRadio(e.target.value)
      setShowTable(false)
      focusElemnt('bdtFromDate')
    }
  }

  document.addEventListener('keydown', function (event) {
    const key = event.key.toLocaleLowerCase()
    if (event.altKey && key === 'q') {
      document.getElementById('isBookingDateWise').focus();
    }
  });
  const handleStateDrop = (val) => {
    setShowTable(false)
    setSrcState(val)
    const filterCityList = srcCityList.filter((item) => item?.stateId === val?.id || val?.id === 0 || item?.id === 0)
    if (filterCityList?.length > 0) {
      setSrcCity({ id: 0, name: 'All' })
    } else {
      setSrcCity(' ')
    }
  }
  const getBranchList = () => {
    if (!srcBranchList || !srcBranchList.length) return []
    if (!srcState?.id && !srcCity?.id) return srcBranchList || []
    if (!srcState?.id && srcCity?.id) return srcBranchList.filter((branch) => branch.cityId === srcCity.id || !branch.id)
    if (srcState?.id && !srcCity?.id) return srcBranchList.filter((branch) => branch.stateId === srcState.id || !branch.id)
    return srcBranchList.filter((branch) => branch.stateId === srcState.id).filter((branch) => branch.cityId === srcCity.id || !branch.id)
  }
  const getDestBranchList = () => {
    if (!destBranchList || !destBranchList.length) return []
    if (!destState?.id && !destCity?.id) return destBranchList || []
    if (!destState?.id && destCity?.id) return destBranchList.filter((branch) => branch.cityId === destCity.id || !branch.id)
    if (destState?.id && !destCity?.id) return destBranchList.filter((branch) => branch.stateId === destState.id || !branch.id)
    return destBranchList.filter((branch) => branch.stateId === destState.id).filter((branch) => branch.cityId === destCity.id || !branch.id)
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', flexWrap: 'nowrap' }}>
          <Item sx={{ ...sx.itemsxGrow, width: '18%' }}>
            <DropDownOA
              id={'bdtSelectCompany'}
              label={'Select Company'}
              searchPlaceholder={'Search Company Name'}
              defaultvalue={companyName || ''}
              value={companyName || ''}
              onClick={() => {
                setShowTable(false)
              }}
              // data={companyDropdown || []}
              disabled={true}
              width={'100%'}
            // dataKey={`name`}
            // idKey={`id`}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <Button
              variant="contained"
              id="bkngDelvryGoBtnOne"
              style={{ ...sx.fullHeight, ...sx.novp }}
              className="btn btn-primary"
              onClick={() => { }}
              disabled
            >
              GO
            </Button>
          </Item>
          <Box
            sx={sx.itemsx}
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '-10px',
              marginLeft: '-10px',
              marginRight: '5px',
              width: '10.6%',
            }}
          >
            <label
              htmlFor={'isBookingDateWise'}
              style={{
                marginBottom: '-12px',
                fontFamily: 'Roboto',
                fontSize: '12px',
                fontWeight: '500',
                color: '#444444',
                flexWrap: 'nowrap',
              }}
            >
              <Radio
                id={'isBookingDateWise'}
                name={`dateWiseRadio`}
                size={'medium'}
                value="Booking"
                checked={selectedRadio === 'Booking'}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e)}
              />
              Booking Date Wise
            </label>
            <label
              htmlFor={'isDelvryDateWise'}
              style={{
                marginBottom: '-10px',
                fontSize: '12px',
                fontFamily: 'Roboto',
                fontWeight: '500',
                color: '#444444',
                flexWrap: 'nowrap',
              }}
            >
              <Radio
                id={'isDelvryDateWise'}
                name={`dateWiseRadio`}
                size={'medium'}
                value="Dilevery"
                checked={selectedRadio === 'Dilevery'}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e)}
              />
              Delivery Date Wise
            </label>
          </Box>
          <Item sx={{ ...sx.itemsxGrow, width: '10.2%' }} className="input--container bookingDatePicker">
            <Datepicker
              label="Select From Date"
              id={'bdtFromDate'}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt('bdtToDate')
                setShowTable(false)
              }}
              width="100%"
            />
          </Item>
          <Item sx={{ ...sx.itemsxGrow, width: '10.2%' }} className="input--container bookingDatePicker">
            <Datepicker
              label="Select To Date"
              id={'bdtToDate'}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt('bkngDelvryGoBtnTwo')
                setShowTable(false)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <Button
              variant="contained"
              id="bkngDelvryGoBtnTwo"
              style={{ ...sx.fullHeight, ...sx.novp }}
              className="btn btn-primary"
              onClick={() => handleClickGo()}
              onKeyDown={(e) => {
                navigation3(e, 'bdtTransactionType', 'isBookingDateWise', () => {
                  handleClickGo()
                })
              }}
            >
              GO
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx, width: '12.7%' }}>
            <DropDownOA
              id={'bdtTransactionType'}
              label={'Transaction Type'}
              data={trnsTypeList || []}
              defaultvalue={transactionType?.name || ''}
              value={transactionType?.name || ''}
              width="100%"
              searchPlaceholder={'Search Transaction Type'}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(val) => {
                setShowTable(false)
                setTransactionType(val)
              }}
              nextId={'bdtSrcState'}
              prevId={'bkngDelvryGoBtnTwo'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '10.2%' }}>
            <DropDownOA
              id={'bdtSrcState'}
              label={'Source State'}
              data={srcStateList || []}
              defaultvalue={srcState?.name || ''}
              value={srcState?.name || ''}
              disabled={disableBtn && transactionType?.id === 'B'}
              width="100%"
              searchPlaceholder={'Search Source State'}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(val) => handleStateDrop(val)}
              nextId={'bdtSrcCity'}
              prevId={'bdtTransactionType'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '10.2%' }}>
            <DropDownOA
              id={'bdtSrcCity'}
              label={'Source City'}
              data={srcCityList.filter((val) => val?.stateId === srcState?.id || !srcState?.id || val?.id === 0) || []}
              defaultvalue={srcCity?.name || ''}
              value={srcCity?.name || ''}
              width="100%"
              disabled={disableBtn && transactionType?.id === 'B'}
              searchPlaceholder={'Search Source City'}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(val) => {
                setShowTable(false)
                setSrcCity(val)
                const filterBranch = srcBranchList.filter((item) => item?.cityId === val?.id || val?.id === 0 || item?.id === 0) || []
                if (filterBranch?.length > 0) {
                  setSrcBranch({ id: 0, name: 'All' })
                } else {
                  setSrcBranch(' ')
                }
              }}
              nextId={'bdtSrcBranch'}
              prevId={'bdtSrcState'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '10.2%' }}>
            <DropDownOA
              id={'bdtSrcBranch'}
              label={'Source Branch'}
              data={getBranchList()}
              defaultvalue={srcBranch?.name || ''}
              value={srcBranch?.name || ''}
              disabled={disableBtn && transactionType?.id === 'B' && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport === 0}
              width="100%"
              searchPlaceholder={'Search Source Branch'}
              dataKey={`name`}
              idKey={`id`}
              listWidth={'170px'}
              onSelect={(val) => {
                setShowTable(false)
                setSrcBranch(val)
              }}
              nextId={'bdtDestState'}
              prevId={'bdtSrcCity'}
            />
          </Item>
        </Box>
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', flexWrap: 'nowrap' }}>
          <Item sx={{ ...sx.itemsx, width: '12.5%' }}>
            <DropDownOA
              id={'bdtDestState'}
              label={'Destination State'}
              data={destStateList || []}
              defaultvalue={destState?.name || ''}
              value={destState?.name || ''}
              width="100%"
              searchPlaceholder={'Search Destination State'}
              dataKey={`name`}
              idKey={`id`}
              disabled={disableBtn && transactionType?.id === 'D'}
              onSelect={(val) => {
                setShowTable(false)
                setDestState(val)
                const filterDestCity = destCityList.filter((item) => item?.stateId === val?.id || val?.id === 0 || item?.id === 0)
                if (filterDestCity?.length > 0) {
                  setDestCity({ id: 0, name: 'All' })
                } else {
                  setDestCity(' ')
                }
              }}
              nextId={'bdtDestCity'}
              prevId={'bdtSrcBranch'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '12.5%' }}>
            <DropDownOA
              id={'bdtDestCity'}
              label={'Destination City'}
              data={destCityList.filter((val) => val?.stateId === destState?.id || !destState?.id || val?.id === 0) || []}
              defaultvalue={destCity?.name || ''}
              value={destCity?.name || ''}
              width="100%"
              searchPlaceholder={'Search Destination City'}
              dataKey={`name`}
              idKey={`id`}
              disabled={disableBtn && transactionType?.id === 'D'}
              onSelect={(val) => {
                setShowTable(false)
                setDestCity(val)
                const filterDestBranch = destBranchList.filter((item) => item?.cityId === val?.id || val?.id === 0 || item?.id === 0)
                if (filterDestBranch?.length > 0) {
                  setDestBranch({ id: 0, name: 'All' })
                } else {
                  setDestBranch(' ')
                }
              }}
              nextId={'bdtDestBranch'}
              prevId={'bdtDestState'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '12.7%' }}>
            <DropDownOA
              id={'bdtDestBranch'}
              label={'Destination Branch'}
              data={getDestBranchList()}
              defaultvalue={destBranch?.name || ''}
              value={destBranch?.name || ''}
              width="100%"
              searchPlaceholder={'Search Destination Branch'}
              dataKey={`name`}
              idKey={`id`}
              disabled={disableBtn && transactionType?.id === 'D'}
              onSelect={(val) => {
                setShowTable(false)
                setDestBranch(val)
              }}
              nextId={'bdtPaymenttype'}
              prevId={'bdtDestCity'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '12.7%' }}>
            <DropDownOA
              id={'bdtPaymenttype'}
              label={'Payment Type'}
              // data={PaymentTypesOptions || []}
              data={(PaymentTypesOptions || []).map((item) => {
                if (UseToPayAsCOD === 1) {
                  if (item.id === 2) {
                    return { ...item, Name: 'COD' };
                  }
                  if (item.id === 7) {
                    return { ...item, Name: 'COD Manual' };
                  }
                  if (item.id === 9) {
                    return { ...item, Name: 'COD DDDV' };
                  }
                  if (item.id === 4) {
                    return null;
                  }
                }
                return item;
              }).filter(Boolean)
              }
              defaultvalue={paymentType?.Name || ''}
              value={paymentType?.Name || ''}
              width="100%"
              searchPlaceholder={'Search Payment Type'}
              dataKey={`Name`}
              idKey={`id`}
              onSelect={(val) => {
                setShowTable(false)
                setPaymentType(val)
              }}
              nextId={'bdtConsignmentType'}
              prevId={'bdtDestBranch'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '12.7%' }}>
            <DropDownOA
              id={'bdtConsignmentType'}
              label={'Consignment Type'}
              data={consTypeList || []}
              defaultvalue={consignmentType?.name || ''}
              value={consignmentType?.name || ''}
              width="100%"
              searchPlaceholder={'Search Consignment Type'}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(val) => {
                setShowTable(false)
                setConsignmentType(val)
              }}
              nextId={'bdtViewType'}
              prevId={'bdtPaymenttype'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '12.7%' }}>
            <DropDownOA
              id={'bdtViewType'}
              label={'View type'}
              data={viewTypeList || []}
              defaultvalue={viewType?.name || ''}
              value={viewType?.name || ''}
              width="100%"
              dataKey={`name`}
              idKey={`id`}
              onSelect={(val) => {
                setShowTable(false)
                setViewType(val)
              }}
              nextId={'bdtSplitButton'}
              prevId={'bdtConsignmentType'}
            />
          </Item>
          <Item
            sx={sx.itemsx}
            tabIndex={0}
            onKeyDown={(e) =>
              navigation3(
                e,
                showTable
                  ? roleRights?.Table1[0]?.AllowExportExcel === 1
                    ? 'bdt-excel-button'
                    : 'isBookingDateWise'
                  : 'isBookingDateWise',
                'bdtViewType',
                () => {
                  handleClick1()
                }
              )
            }
          >
            {companyId !== 406 ? (
              <SplitButton
                options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                hideToggle={false}
                onClick1={() => {
                  handleClick1()
                }}
                onClick2={handleClick2}
                id1={'bdtSplitButton'}
                prevID={'bdtViewType'}
              />
            ) : (
              <Button
                variant="contained"
                id="bdtSplitButton"
                style={{ ...sx.fullHeight, ...sx.novp }}
                className="btn btn-primary"
                onClick={() => handleClick1()}
                onKeyDown={(e) => {
                  navigation3(e, '', 'bdtViewType', () => {
                    handleClick1()
                  })
                }}
              >
                GENERATE NEW FORMAT
              </Button>
            )}
          </Item>
        </Box>
      </Item>
      {/* {viewType?.id === 1 ? (
        showTable ? (
          <Item>
            {companyId === 406 ? (
              <BkngDelvryTrackingTableTwo dataValues={dataValues} filterObj={filterObj} reportName={reportName} columns={columnsSTA} />
            ) : (
              <BkngDelvryTrackingTable dataValues={dataValues} UseFormattedLRinReports={UseFormattedLRinReports} filterObj={filterObj} reportName={reportName} manageColumn={manageColumn.filter((obj) => obj.isSelected)} />
            )}
          </Item>
        ) : (
          <></>
        )
      ) : (
        showTable ? (
          <Item>
            <BkngDelvryTrackingSummary dataValues={dataValues} />
          </Item>
        ) : (
          <></>
        )
      )}
      {showModal && modalType === 'showManageColumn' && (
        <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={updateModal} />
      )} */}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, getCargoRoleRightsConfigListAll, getTrackingReportFilters, getTrackingReportTableData, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(BkngDelvryTrackingReport)
